import { render, staticRenderFns } from "./Course_show.vue?vue&type=template&id=f502a912&scoped=true&"
import script from "./Course_show.vue?vue&type=script&lang=js&"
export * from "./Course_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f502a912",
  null
  
)

export default component.exports